module.exports = __webpack_public_path__ + "img/weather26.3df72cf7.png";